import Physios from "./Physios";

export default function Medici() {
  return <Physios category="medico" />;
}
